import React from 'react'

function ConteneurAttente({nbConteneurFalse}) {
  return (
    <div className="col-md-6 col-xl-3 mb-4">
        <div className="card shadow border-start-info py-2">
            <div className="card-body">
                <div className="row align-items-center no-gutters">
                    <div className="col me-2">
                        <div className="text-uppercase text-info fw-bold text-xs mb-1"><span>Conteneurs en attente</span></div>
                        <div className="row g-0 align-items-center">
                            <div className="col-auto">
                                <div className="text-dark fw-bold h5 mb-0 me-3">
                                    <span>{nbConteneurFalse}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icon-tabler-circle-dashed fa-2x text-gray-300">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M8.56 3.69a9 9 0 0 0 -2.92 1.95"></path>
                            <path d="M3.69 8.56a9 9 0 0 0 -.69 3.44"></path>
                            <path d="M3.69 15.44a9 9 0 0 0 1.95 2.92"></path>
                            <path d="M8.56 20.31a9 9 0 0 0 3.44 .69"></path>
                            <path d="M15.44 20.31a9 9 0 0 0 2.92 -1.95"></path>
                            <path d="M20.31 15.44a9 9 0 0 0 .69 -3.44"></path>
                            <path d="M20.31 8.56a9 9 0 0 0 -1.95 -2.92"></path>
                            <path d="M15.44 3.69a9 9 0 0 0 -3.44 -.69"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ConteneurAttente